module.exports = __webpack_public_path__ + "img/worship_avl.517eaedd.svg";